/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityMalwareDataSample } from './ControlEntityMalwareDataSample';
import {
    ControlEntityMalwareDataSampleFromJSON,
    ControlEntityMalwareDataSampleFromJSONTyped,
    ControlEntityMalwareDataSampleToJSON,
} from './ControlEntityMalwareDataSample';

/**
 * 
 * @export
 * @interface ControlEntityMalwareData
 */
export interface ControlEntityMalwareData {
    /**
     * 
     * @type {number}
     * @memberof ControlEntityMalwareData
     */
    total?: number;
    /**
     * 
     * @type {Array<ControlEntityMalwareDataSample>}
     * @memberof ControlEntityMalwareData
     */
    samples?: Array<ControlEntityMalwareDataSample>;
}

/**
 * Check if a given object implements the ControlEntityMalwareData interface.
 */
export function instanceOfControlEntityMalwareData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityMalwareDataFromJSON(json: any): ControlEntityMalwareData {
    return ControlEntityMalwareDataFromJSONTyped(json, false);
}

export function ControlEntityMalwareDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityMalwareData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'samples': !exists(json, 'samples') ? undefined : ((json['samples'] as Array<any>).map(ControlEntityMalwareDataSampleFromJSON)),
    };
}

export function ControlEntityMalwareDataToJSON(value?: ControlEntityMalwareData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'samples': value.samples === undefined ? undefined : ((value.samples as Array<any>).map(ControlEntityMalwareDataSampleToJSON)),
    };
}

